exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".article-list{background-color:#fbfbfb;box-shadow:inset 0 0 6px 0 hsla(0,0%,79.6%,.5),0 2px 4px 0 rgba(0,0,0,.5)}", ""]);

